module.exports = __webpack_public_path__ + "img/scrisori-front.dbfeed26.jpg";